import { getLang } from "../i18n/translate";
import type { SceneDefinition } from "../types/navigation";

export const getVideoSource = (scene: SceneDefinition, season: string) => {
  const videoName = scene.videoSrc || scene.id;
  return `video/${season}/${videoName}.mp4`;
};

export const getSubtitlesSource = (scene: SceneDefinition, season: string) => {
  if (!scene.subtitles) return undefined;
  const videoName = scene.videoSrc || scene.id;
  return `subtitles/${season}/${getLang()}/${videoName}.vtt`;
};
